import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLanguage } from '@/legacy/utils/language';
import { i18nResources, DEFAULT_LANGUAGE } from './resources';

const language = getLanguage();

i18n.use(initReactI18next).init({
	resources: i18nResources,
	lng: language,
	fallbackLng: DEFAULT_LANGUAGE,
	interpolation: {
		escapeValue: false,
	},
	debug: false,
	cache: {
		enabled: false,
	},
	missingKeyHandler: (lng, _, key) => {
		console.warn(`Missing translation for key: "${key}" in language: "${lng}"`);
		return `Missing: ${key}`;
	},
	postProcess: 'missingKeyHandler',
});

export default i18n;

export * from './tradPrefix';
export * from './useLanguageOptions';
